<template>
    <div v-if="this.ordersMessages" class="profile-cont">
        <div class="page-title-wrap">
            <h1 class="page-title">
                {{this.ordersMessages.ORDERS_HISTORY}}
            </h1>
            <div class="show-on-time">
                <div class="show-on-page">
                    <div class="label">{{this.ordersMessages.SHOW}}</div>
                    <div class="dropdown">
                        <a class="dropdown-link" href="javascript:void(0)" data-value="" role="button"
                           data-toggle="dropdown"
                           aria-haspopup="true" aria-expanded="false">
                            {{this.ordersMessages.CURRENT_QUANTITY}}
                        </a>
                        <div class="dropdown-menu">
                            <a v-for="quantity in this.ordersMessages.QUANTITY_LIST" class="dropdown-item"
                               v-on:click="changeQuantity(quantity.VALUE)"
                               href="javascript:void(0)">{{quantity.DESCR}}</a>
                        </div>
                    </div>
                    <a href="#" class="show-time js-show-time"></a>
                </div>

                <div class="input-group input-daterange js-order-daterange">
                    <div class="input-group-addon">{{this.ordersMessages.FROM}}</div>
                    <datepicker input-class="form-control order-dates" format="dd.MM.yyyy" :language="this.ordersMessages.CALENDAR_LANG"
                                :disabledDates="getAllowedDate"
                                v-model="dateFrom" v-on:input="changeDateFrom"></datepicker>
                    <div class="input-group-addon">{{this.ordersMessages.TO}}</div>
                    <datepicker input-class="form-control order-dates" calendar-class="mobile-order-calendar" format="dd.MM.yyyy" :language="this.ordersMessages.CALENDAR_LANG"
                                :disabledDates="getAllowedDate"
                                v-model="dateTo" v-on:input="changeDateTo"></datepicker>
                </div>
            </div>
        </div>
        <div class="order-wrap">
            <order v-for="order in this.orders" key="order.id" :order="order"></order>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Order from "vueComponents/orders/Order";
    import Datepicker from 'vuejs-datepicker';
    import _u from "jsAssets/utils/index";

    export default {
        name: "orders-history",

        props: ['user_id', 'from', 'to'],

        components: {
            'order': Order,
            'datepicker': Datepicker

        },

        data() {
            return {
                quantity: "",
                dateFrom: this.from,
                dateTo: this.to,
            }
        },

        computed: {

            ...mapGetters('orders', [
                'orders', 'ordersMessages'
            ]),

            getAllowedDate: function () {
                return {
                    to: new Date(this.from),
                    from: new Date(this.to)
                }
            },
        },

        mounted() {
            this.$store.dispatch('orders/getOrders', {
                userId: this.user_id,
                dateFrom: _u.formatDate(new Date(this.dateFrom)),
                dateTo: _u.formatDate(new Date(this.dateTo)),
                quantity: this.quantity
            });
        },

        methods: {
            changeDateFrom() {
                this.$store.dispatch('orders/getOrders', {
                    userId: this.user_id,
                    dateFrom: _u.formatDate(new Date(this.dateFrom)),
                    dateTo: _u.formatDate(new Date(this.dateTo)),
                    quantity: this.quantity
                });
            },
            changeDateTo() {
                this.$store.dispatch('orders/getOrders', {
                    userId: this.user_id,
                    dateFrom: _u.formatDate(new Date(this.dateFrom)),
                    dateTo: _u.formatDate(new Date(this.dateTo)),
                    quantity: this.quantity
                });
            },
            changeQuantity(value) {
                this.quantity = value;

                this.$store.dispatch('orders/getOrders', {
                    userId: this.user_id,
                    dateFrom: _u.formatDate(new Date(this.dateFrom)),
                    dateTo: _u.formatDate(new Date(this.dateTo)),
                    quantity: this.quantity
                });

            },
        }
    }


</script>